import React from "react";
import { Link, useLocation, useHistory } from "react-router-dom";
import { useDispatch } from "react-redux";

import { RiDashboardLine, RiHealthBookLine } from "react-icons/ri";
import { AiOutlineSetting } from "react-icons/ai";
import { FiActivity } from "react-icons/fi";
import { HiOutlineAcademicCap } from "react-icons/hi";
import { TiGroupOutline } from "react-icons/ti";
import { CgLogOff } from "react-icons/cg";

import { signOut } from "../store/actions/AuthActions";
function Sidebar() {
  const history = useHistory();
  const dispatch = useDispatch();
  const handleSignOut = () => {
    dispatch(signOut());
    history.push("/");
  };
  const location = useLocation();

  const links = [
    {
      name: "Dashboard",
      icon: <RiDashboardLine className="text-xl ml-2" />,
      activeStatus: "/home",
      path: "/home",
    },

    {
      name: "Services",
      icon: <FiActivity className="text-xl ml-2" />,
      activeStatus: "/services",
      path: "/services",
    },
    {
      name: "Performance",
      icon: <HiOutlineAcademicCap className="text-xl ml-2" />,
      activeStatus: "/academics",
      path: "/academics",
    },
    {
      name: "Insurance",
      icon: <RiHealthBookLine className="text-xl ml-2" />,
      activeStatus: "/insurances",
      path: "/insurances",
    },
    {
      name: "Assocciations",
      icon: <TiGroupOutline className="text-xl ml-2" />,
      activeStatus: "/assocciations",
      path: "/assocciations",
    },
    {
      name: "Settings",
      icon: <AiOutlineSetting className="text-xl ml-2" />,
      activeStatus: "/settings",
      path: "/settings",
    },
  ];
  return (
    <div className="bg-white text-gray-500 sidebar xl:w-60 lg:w-52 md:w-48 w-14 flex flex-col  text-xs h-screen overflow-y-scroll top-0 border-r">
      {/* quick links */}
      <div className="p-2 px-0 pt-5 w-full font-semibold">
        {links.map((link, i) => {
          return (
            <Link
              className={
                location.pathname.includes(link.activeStatus)
                  ? "flex flex-row py-3 hover:text-indigo-600 active-link border-l-indigo-500 rounded rounded-l-none"
                  : "flex flex-row py-3 hover:text-indigo-600"
              }
              key={i}
              to={link.path}
            >
              {link.icon}{" "}
              <p className="md:block hidden m-auto ml-4">{link.name}</p>
            </Link>
          );
        })}
      </div>

      {/* logout  */}
      <div className="mt-auto mb-20 bottom-7">
        <button
          className="flex flex-row p-2 pb-1 font-medium"
          onClick={() => {
            handleSignOut();
          }}
        >
          <CgLogOff className="text-xl" />{" "}
          <p className="xl:block lg:block md:block  hidden m-auto ml-4">
            Logout
          </p>
        </button>
      </div>
    </div>
  );
}

export default Sidebar;
